const xs = 599;
const sm = 600;
const md = 960;
const lg = 1240;
const xl = 1440;
const wd = 1920;

module.exports = {
  xs,
  sm,
  md,
  lg,
  xl,
  wd,
  customMedia: {
    "--xs": `(max-width: ${xs}px)`,
    "--sm": `(min-width: ${sm}px)`,
    "--md": `(min-width: ${md}px)`,
    "--lg": `(min-width: ${lg}px)`,
    "--xl": `(min-width: ${xl}px)`,
    "--wd": `(min-width: ${wd}px)`,
  },
};
